module.exports = __webpack_public_path__ + "static/media/icon-logout.ed1caf9d.svg";